<template>
	<div class="personSet_page">
		<div class="info_content">
			<div class="info_content_main">
				<ul>
					<li>
						<dl>
							<dd>交易时间</dd>
							<dd>项目</dd>
							<dd>交易金额</dd>
							<dd>&nbsp;</dd>
						</dl>
					</li>
					<li v-for="(item,index) in transactionInfo" :key="index">
						<dl>
							<dd>{{item.time}}</dd>
							<dd>{{item.object}}</dd>
							<dd>{{item.money}}</dd>
							<dd><button>查看发票</button></dd>
						</dl>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'transactionInfo',
	  data () {
	    return {
			transactionInfo:[{
				id:1,
				time:'2019年12月31日',
				object:'特许金融分析师',
				money:'1500元人民币'
			},{
				id:2,
				time:'2019年12月31日',
				object:'特许金融分析师',
				money:'1500元人民币'
			},{
				id:3,
				time:'2019年12月31日',
				object:'特许金融分析师',
				money:'1500元人民币'
			}]
	    }
	  }
	}
</script>

<style scoped="scoped">
	.info_content{
		width:600px;
		margin-left:100px;
		background-color: rgba(45,47,58,0.5);
		border-radius:20px;
		padding:0 30px 30px 30px;
		margin-top: -20px;
	}
	.info_content_main{
		margin-top:20px;
		display: flex;
	}
	.info_content_main ul{
		width: 100%;
		position: relative;
		overflow: hidden;
		zoom:1
	}
	.info_content_main ul li{
		width: 100%;
		height: 60px;
		line-height: 60px;
		float: left;
		list-style: none;
		border-bottom:1px rgba(199,199,199) solid;
	}
	.info_content_main ul li dl{
		width: 100%;
		height: 60px;
		line-height: 60px;
	}
	.info_content_main ul li dl dd{
		width: 25%;
		height: 60px;
		line-height: 60px;
		float: left;
		list-style: none;
		font-size:14px;
		color:#C7C7C7;
		text-align:center;
	}
	.info_content_main ul li dl dd button{
		border:1px #fff solid;
		font-size:14px;
		color:#fff;
		background: unset;
		border-radius:20px;
	}
	.info_content_main ul li dl dd button:hover{
		cursor: pointer;
		color:#000;
		background: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/components/personSet/transactionInfo.vue